import {$qsAll} from '../../@shared/ts/dom';
import {doAction} from '../../@shared/ts/hooks';
import {type CloseFlags} from '../../express-checkout-button/ts/sdk-checkout';
import {requestCartCalculation} from './payment/order';
import {startModalLoading, stopModalLoading} from './reducers/environmentReducer';
import {store} from './store';

function checkoutCloseFlags() {
	const flags: CloseFlags = {};

	return {
		getFlags() {
			return {...flags};
		},
		setRedirect(url: string) {
			flags.redirect = url;
		},
		setReload() {
			flags.reload = true;
		},
		setRefresh() {
			flags.refresh = true;
		},
		resetFlags() {
			delete flags.redirect;
			delete flags.reload;
			delete flags.refresh;
		},
	};
}

const SDKFlags = checkoutCloseFlags();

function initSDKEvents() {
	window.addEventListener('message', async event => {
		if (event.origin !== location.origin) {
			return;
		}

		if (event.data.type === 'peachpay_checkout_opened') {
			// When the express checkout is reopened we want all existing notices to be removed
			$qsAll('.pp-notice').forEach($el => {
				$el.remove();
			});

			// We also want the Express checkout to be up to date with the current cart
			store.dispatch(startModalLoading());
			await requestCartCalculation('pull');
			await doAction('after_modal_open');
			store.dispatch(stopModalLoading());

			return;
		}

		if (event.data.type === 'peachpay_checkout_closed') {
			window.top?.postMessage({type: 'peachpay_checkout_close_flags', data: SDKFlags.getFlags()}, location.origin);

			SDKFlags.resetFlags();
		}
	});
}

function closeCheckout() {
	if (window.top === window) {
		window.location.href = '/cart';
		return;
	}

	window.top?.postMessage({type: 'peachpay_checkout_close'}, location.origin);
}

export {
	initSDKEvents,

	SDKFlags,

	closeCheckout,
};
